import { OrderResponseDto } from '@planning/app/api'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { HoldsChipByJourneyId } from './DisplayHoldsButton'

interface Props {
  order: Pick<OrderResponseDto, 'holds'>
  hideText?: boolean
}

export const HoldsDrawerButton: FC<Props> = observer(({ order, hideText }) => {
  const containerJourneyId = order.holds?.[0]?.containerJourneyId
  return <HoldsChipByJourneyId containerJourneyId={containerJourneyId} hideText={hideText} />
})
